module.exports = __webpack_public_path__ + "img/layout3_preview.6eb47d96.jpg";